import type { CSSProperties } from 'react';
import type { Theme } from '@mui/material';

export const styles = {
  numbersHeaderLabel: (theme: Theme) => ({
    ...(theme.typography.body2 as CSSProperties),
    textAlign: 'center',
    wordWrap: 'break-word',
    fontWeight: 'bold',
    maxWidth: '100%',
  }),
};
